import { render, staticRenderFns } from "./AlertMessage.vue?vue&type=template&id=2f42b776&scoped=true&lang=pug&"
import script from "./AlertMessage.vue?vue&type=script&lang=js&"
export * from "./AlertMessage.vue?vue&type=script&lang=js&"
import style0 from "./AlertMessage.vue?vue&type=style&index=0&id=2f42b776&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f42b776",
  null
  
)

export default component.exports